import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { ERROR_COLORS, GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { Button, Checkbox, IconButton, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  CloseIcon,
  MessageChatCircleIcon,
  SadEmptyIcon,
  SadFilledIcon,
  SmileEmptyIcon,
  SmileFilledIcon
} from 'asterX-UI/Icons'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import useModalbar from 'modules/Modalbar/useModalbar'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  carName: {
    fontSize: 14,
    fontWeight: 600
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 32
  },
  row: {
    display: 'flex',
    gap: 75
  },
  blockHeading: {
    width: 110,
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 11
  },
  check: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14
  },
  comment: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    marginLeft: 10,
    fontSize: 14
  }
}))
const REQUIRED_FIELDS = [
  { key: 'resultConfiguration', value: 'Комплектация' },
  { key: 'resultExternal', value: 'Внешний вид' },
  { key: 'resultPrice', value: 'Цена' },
  { key: 'resultTechnical', value: 'Тех состояние' }
]
const CarInspection = ({
  onClose,
  car = {},
  title = '',
  isDisabled = false,
  initialData,
  sendInspectionResult = async (car, result) => {}
}) => {
  const classes = useStyles()
  const [inspectionList, setInspectionList] = useState(initialData)
  const { callModalbar } = useModalbar()
  const checkResult = () => {
    if (!isDisabled) {
      const newErrors = REQUIRED_FIELDS.map(v =>
        !!inspectionList?.[v.key] ? null : v.value
      ).filter(v => !!v)
      if (newErrors.length > 0) {
        callModalbar(
          'Заполните следующие:',
          <ul>
            {newErrors.map(v => (
              <li>{v}</li>
            ))}
          </ul>,
          {
            btnText: 'Понятно'
          }
        )
        return false
      }
      return true
    }
    return true
  }

  const handleClick = async () => {
    const isChecked = checkResult()

    if (isDisabled) {
      return onClose()
    }
    if (isChecked) {
      const isOk = await sendInspectionResult(car, inspectionList)

      if (isOk) {
        onClose()
      }
    }
  }
  const handleClose = () => {
    if (checkResult()) {
      return onClose()
    }
  }

  const onIsNotDemonstrated = () => {
    const isNotDemonstrated = !inspectionList.isNotDemonstrated
    setInspectionList({
      ...(isNotDemonstrated
        ? {
            resultPrice: '',
            resultConfiguration: '',
            resultExternal: '',
            resultTechnical: '',
            resultTestDriveExpress: null
          }
        : inspectionList),

      isNotDemonstrated
    })
  }
  return (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <div className={classes.heading}>Результат осмотра</div>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={handleClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <div className={classes.container}>
        <div className={classes.carName}>
          {title ? title : `${car.marka} ${car.model} ${car.year}`}
        </div>
        <div className={classes.row}>
          <div className={classes.result}>
            <div className={classes.blockHeading}>Цена</div>
            <div className={classes.radioRow}>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultPrice: inspectionList.resultPrice === '1' ? '' : '1'
                  })
                }
                style={{ color: '#13BB42' }}
                size={'small'}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultPrice === '1' ? (
                  <SmileFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SmileEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultPrice: inspectionList.resultPrice === '0' ? '' : '0'
                  })
                }
                style={{ color: ERROR_COLORS[700] }}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultPrice === '0' ? (
                  <SadFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SadEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
            </div>
          </div>
          <div className={classes.result}>
            <div className={classes.blockHeading}>Комплектация</div>
            <div className={classes.radioRow}>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultConfiguration:
                      inspectionList.resultConfiguration === '1' ? '' : '1'
                  })
                }
                style={{ color: '#13BB42' }}
                size={'small'}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultConfiguration === '1' ? (
                  <SmileFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SmileEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultConfiguration:
                      inspectionList.resultConfiguration === '0' ? '' : '0'
                  })
                }
                style={{ color: ERROR_COLORS[700] }}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultConfiguration === '0' ? (
                  <SadFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SadEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
            </div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.result}>
            <div className={classes.blockHeading}>Внешний вид</div>
            <div className={classes.radioRow}>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultExternal:
                      inspectionList.resultExternal === '1' ? '' : '1'
                  })
                }
                style={{ color: '#13BB42' }}
                size={'small'}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultExternal === '1' ? (
                  <SmileFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SmileEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultExternal:
                      inspectionList.resultExternal === '0' ? '' : '0'
                  })
                }
                style={{ color: ERROR_COLORS[700] }}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultExternal === '0' ? (
                  <SadFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SadEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
            </div>
          </div>

          <div className={classes.result}>
            <div className={classes.blockHeading}>Тех состояние</div>

            <div className={classes.radioRow}>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultTechnical:
                      inspectionList.resultTechnical === '1' ? '' : '1'
                  })
                }
                style={{ color: '#13BB42' }}
                size={'small'}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultTechnical === '1' ? (
                  <SmileFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SmileEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
              <IconButton
                onClick={() =>
                  setInspectionList({
                    ...inspectionList,
                    resultTechnical:
                      inspectionList.resultTechnical === '0' ? '' : '0'
                  })
                }
                style={{ color: ERROR_COLORS[700] }}
                disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              >
                {inspectionList.resultTechnical === '0' ? (
                  <SadFilledIcon style={{ fontSize: 28 }} />
                ) : (
                  <SadEmptyIcon style={{ fontSize: 28 }} />
                )}
              </IconButton>
            </div>
          </div>
        </div>

        <div className={classes.checkboxes}>
          <div className={classes.check}>
            <Checkbox
              disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              checked={!!inspectionList.resultTestDrive}
              onChange={() =>
                setInspectionList({
                  ...inspectionList,
                  resultTestDrive: !inspectionList.resultTestDrive
                })
              }
              color={'primary'}
            />
            <div>Тест-драйв проведен</div>
          </div>
          <div className={classes.check}>
            <Checkbox
              disabled={isDisabled || !!inspectionList.isNotDemonstrated}
              onChange={() =>
                setInspectionList({
                  ...inspectionList,
                  resultTestDriveExpress: !inspectionList.resultTestDriveExpress
                })
              }
              color={'primary'}
              checked={!!inspectionList.resultTestDriveExpress}
            />
            <div>Экспресс-сервис под демонстрацию</div>
          </div>
          {inspectionList.isNotDemonstrated && (
            <div className={classes.check}>
              <Checkbox
                disabled={isDisabled}
                color={'primary'}
                checked={!!inspectionList.isNotDemonstrated}
              />
              <div>Авто продемонстрирован мобильно</div>
            </div>
          )}
        </div>
        {isDisabled ? (
          <div className={classes.comment}>
            <MessageChatCircleIcon
              style={{ fontSize: 24, color: GRAY_COLORS['500'] }}
            />
            <div>
              {inspectionList.comment ? inspectionList.comment : 'Коммент'}
            </div>
          </div>
        ) : (
          <TextField
            label={'Комментарий'}
            className={classes.textField}
            multiline
            minRows={3}
            value={inspectionList.comment}
            onChange={e =>
              setInspectionList({ ...inspectionList, comment: e.target.value })
            }
          />
        )}
      </div>
      <Button
        variant={'contained'}
        color={'primary'}
        fullWidth
        onClick={handleClick}
      >
        {isDisabled ? 'Закрыть' : 'Сохранить'}
      </Button>
    </PageContainerMobile>
  )
}

export default CarInspection
